import { format, setHours, setMinutes } from 'date-fns';
import SVGImage from '../layout/SVGImage';
import React from 'react';

interface PowerOutageScheduleTimepickerProps {
  testId?: string;
  className?: string;
  disabled?: boolean;
  time?: Date;
  onChange?: (value: Date) => void;
}

export const PowerOutageScheduleTimepicker: React.FC<
  PowerOutageScheduleTimepickerProps
> = ({ testId, className, disabled, time, onChange }) => {
  return (
    <div
      className={`flex items-center justify-center rounded-[5px] border border-light-6 bg-white ${disabled ? 'border-opacity-50' : ''} ${className}`}
      data-testid={testId}
    >
      <SVGImage className="my-[10px] ml-[14px]" name="timepicker-prefix" />
      <input
        data-testid={`${testId}-hour`}
        className="noto-13-normal text-dark-10 focus:outline-none disabled:opacity-50"
        type="text"
        disabled={disabled}
        onChange={(e) => {
          if (!time) return null;
          const copiedDate = new Date(time);
          const hourString = e.target.value;
          const hour = parseInt(hourString, 10);

          // Validate if hour is within the acceptable range (0-23)
          if (isNaN(hour) || hour < 0 || hour > 23) {
            return null;
          }

          onChange?.(setHours(copiedDate, hour));
        }}
        value={time ? format(time, 'HH') : '00'}
      />
      <span className="noto-13-normal text-dark-10">:</span>
      <input
        data-testid={`${testId}-minute`}
        disabled={disabled}
        className="noto-13-normal text-dark-10 focus:outline-none disabled:opacity-50"
        type="text"
        onChange={(e) => {
          if (!time) return null;
          const copiedDate = new Date(time);
          const minuteString = e.target.value;
          const minute = parseInt(minuteString, 10);

          // Validate if hour is within the acceptable range (0-60)
          if (isNaN(minute) || minute < 0 || minute > 59) {
            return null;
          }

          onChange?.(setMinutes(copiedDate, minute));
        }}
        value={time ? format(time, 'mm') : '00'}
      />
    </div>
  );
};
